import axios from 'axios';

/**
 * axios for backend JSON calls. Laravel's `web` middleware sets the XSRF-TOKEN
 * cookie, which axios automatically sends back as X-XSRF-TOKEN — so POST/PUT/
 * DELETE to the planning/api endpoints are CSRF-protected out of the box.
 */
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
